const NXStock = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4287_3218)">
        <path
          d="M5.25 8.25H1C0.723858 8.25 0.5 8.47386 0.5 8.75V13C0.5 13.2761 0.723858 13.5 1 13.5H5.25C5.52614 13.5 5.75 13.2761 5.75 13V8.75C5.75 8.47386 5.52614 8.25 5.25 8.25Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 8.25H8.75C8.47386 8.25 8.25 8.47386 8.25 8.75V13C8.25 13.2761 8.47386 13.5 8.75 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V8.75C13.5 8.47386 13.2761 8.25 13 8.25Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.13 0.5H4.88C4.60386 0.5 4.38 0.723858 4.38 1V5.25C4.38 5.52614 4.60386 5.75 4.88 5.75H9.13C9.40615 5.75 9.63 5.52614 9.63 5.25V1C9.63 0.723858 9.40615 0.5 9.13 0.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4287_3218">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NXStock;
